import React from "react";

// Shown instead of the build when the backend refuses to analyze (HTTP 409):
// nothing uploaded, still ingesting, no rfp-classified document, or ingestion
// failed. Starting a 1–4 minute agentic build that can only produce an empty
// outline is worse than saying plainly what's missing.

const ICONS = {
  ingesting: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 7 12 12 15.5 14" />
    </svg>
  ),
  default: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),
};

const TITLES = {
  no_documents: "No documents yet",
  no_rfp_documents: "No RFP document found",
  ingesting: "Still ingesting your document",
  ingest_failed: "Ingestion didn't finish",
  build_failed: "Couldn't build the proposal",
  not_ready: "Not ready to build yet",
};

// Single action by design: every one of these states is resolved on the project
// files page — upload something, fix a document type, or watch ingestion finish.
// A "Try again" here would just re-ask a question whose answer hasn't changed.
const ProposalNotReadyView = ({ blocked, onGoToDocuments }) => {
  const reason = blocked?.reason || "not_ready";
  const waiting = reason === "ingesting";
  return (
    <div className="h-full flex items-center justify-center bg-white rounded-[10px] border border-[#ECE9EE] shadow-sm p-6">
      <div className="max-w-[420px] text-center">
        <div
          className={`w-12 h-12 rounded-full mx-auto flex items-center justify-center ${
            waiting ? "bg-[#FFFBEB] text-[#B45309]" : "bg-[#F4F4F5] text-[#6B7280]"
          }`}
        >
          {waiting ? ICONS.ingesting : ICONS.default}
        </div>
        <h2 className="mt-4 font-outfit text-[18px] font-semibold text-[#18101C]">
          {TITLES[reason] || TITLES.not_ready}
        </h2>
        <p className="mt-1.5 font-outfit text-[13.5px] leading-relaxed text-[#6B7280]">
          {blocked?.detail}
        </p>
        {onGoToDocuments && (
          <div className="mt-5 flex justify-center">
            <button
              type="button"
              onClick={onGoToDocuments}
              className="px-4 py-2 rounded-lg bg-[#A04A97] text-white font-outfit text-[13.5px] font-medium hover:bg-[#8B3F83] transition-colors"
            >
              Go to documents
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProposalNotReadyView;
